var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canMakePayments)?_c('div',{class:_vm.buttonClasses,on:{"click":_vm.onClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }